import { useDoctoralCommitteeDelete } from '@/module/Author/DoctoralCommittee';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface DoctoralCommitteeDeleteButtonProps {
  doctoralCommitteeId: Id;
}

export function DoctoralCommitteeDeleteButton({ doctoralCommitteeId }: DoctoralCommitteeDeleteButtonProps) {
  const mutation = useDoctoralCommitteeDelete(doctoralCommitteeId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      size="xs"
      {...deleteProps}
    />
  );
}
